import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-feature-dialog', {
  mixins: [eventListenerMixin],

  properties: {
    key: String,
  },

  ready() {
    this.listenTo(this.querySelector('tr-dialog'), 'tao:closed', this.removeDialog.bind(this));
    this.listenTo(this.querySelector('.tr-button'), 'click', this.removeDialog.bind(this));
  },

  removeDialog() {
    this.remove();
    if (this.key) {
      $.post('/new_feature_confirmations', {
        metadata_key: this.key,
        metadata_value: false,
      });
    }
  },

  disconnected() {
    this.stopListening();
  },
});
